import React from 'react';
import PropTypes from 'prop-types';
import SelectFieldMultiSelectWithGroups from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelectWithGroups';
import compose from 'recompose/compose';
import subcategoryFieldUpdater from 'components/hoc/subcategoryFieldUpdater';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { fetchCategories } from 'store/actions/categories/fetchCategories';

class SubcategoriesFilter extends React.Component {
    componentDidMount() {
        const { categories, fetchCategories } = this.props;

        if (utils.isEmpty(categories)) {
            fetchCategories({
                size: 96,
                offset: 0,
                sort: {
                    field: 'name',
                    order: 'asc',
                },
            });
        }
    }

    render() {
        const {
            filteredSubcategoriesList,
            source,
        } = this.props;

        return <SelectFieldMultiSelectWithGroups
            dataset={ filteredSubcategoriesList }
            fullWidth={ true }
            label='resources.products.fields.subcategory_id'
            source={ source }
            { ...this.props }
        />;
    }
}

SubcategoriesFilter.propTypes = {
    categories: PropTypes.array,
    fetchCategories: PropTypes.func.isRequired,
    filteredSubcategoriesList: PropTypes.object,
    source: PropTypes.string.isRequired,
};

const categoriesSelector = (state) => {
    return state.categories.data;
};

const getCategories = createSelector(
    categoriesSelector,
    (categories) => {
        return utils.map(categories, function (item) {
            return {
                id: item.id,
                name: item.name,
            };
        });
    },
);

const mapStateToProps = (state, props) => {
    return {
        categories: getCategories(state, props),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchCategories: (payload) => {
            dispatch(fetchCategories(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    subcategoryFieldUpdater,
);

export default enhance(SubcategoriesFilter);



// WEBPACK FOOTER //
// ./src/components/list/Filters/types/SubcategoriesFilter.js